import { useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import API from '@/config/api';

const detectPlatform = () => {
  const ua = navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
};

const deviceId = () => {
  let id = localStorage.getItem('ck-device-id');
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('ck-device-id', id);
  }
  return id;
};

// Records that a signed-in user is running the installed (home-screen) app.
export const AppInstallTracker = () => {
  const { user, getAuthHeaders } = useAuth();
  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!user || !standalone || sessionStorage.getItem('ck-install-pinged') === user.id) return;
    axios.post(`${API}/app-installs/ping`, { device_id: deviceId(), platform: detectPlatform() }, getAuthHeaders())
      .then(() => sessionStorage.setItem('ck-install-pinged', user.id))
      .catch(() => {});
  }, [user, getAuthHeaders]);
  return null;
};
